import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { BarcodeScanningModalComponent } from '../barcode/barcode-scan-modal-component';
import { ExtendedBarcode } from '../barcode/barcode-scanning.service';

@Component({
  selector: 'swodoc-node-gs1-barcode',
  templateUrl: 'swodoc-node-gs1-barcode.html',
  styleUrls: ['swodoc-node-gs1-barcode.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class SwodocNodeGs1Barcode implements OnInit {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('input', { static: true }) public input: any;
  public isMobile: boolean;

  constructor(private _modalCtrl: ModalController) {}

  async ngOnInit() {
    this.isMobile = Capacitor.isNativePlatform();
  }

  get text(): string {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      return this.node.responses[0].value;
    }

    return '';
  }
  set text(value: string) {
    this.node.responses = this.node.responses || [];
    if (this.node.responses.length === 0) {
      this.node.responses.push({ value });
    } else {
      this.node.responses[0] = { value };
    }
    if (this.node.responses && this.node.responses.length > 1 && this.node.responses[1].value) {
      this.node.responses[1].value = undefined;
    }
    this.changed.emit(this.node);
  }

  setFocus() {
    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 0);
  }

  /**
   * open modal that scans barcode
   * on capacitor with ionic we need a workaround in code because web view is in foreground and scanner is not visble
   */
  async scan() {
    const scanDialogue = await this._modalCtrl.create({
      component: BarcodeScanningModalComponent,
      // Set `visibility` to `visible` to show the modal (see global.scss)
      cssClass: 'barcode-scanning-modal',
      showBackdrop: false,
      componentProps: {
        parseGS1: true,
        // you could set certain formats or lensFacing (front/back) here
        // formats: formats,
        // lensFacing: lensFacing,
      },
    });

    scanDialogue.onDidDismiss().then(result => {
      const barcode: ExtendedBarcode | undefined = result.data?.barcode;
      if (!barcode) {
        return;
      }
      if (!barcode.isGs1Barcode) {
        this.text = barcode?.displayValue;
        return;
      }

      if (this.node.options.gs1Field) {
        this.text = barcode.gs1Data.find(item => item.ai === this.node.options.gs1Field)?.data ?? barcode?.displayValue;
      } else {
        this.text = barcode?.displayValue;
      }
    });
    scanDialogue.present();
  }
}
